module.exports = {
    "collapse": `Zbali\u{165}`,
    "expand": `Rozbali\u{165}`
};


//# sourceMappingURL=sk-SK.main.js.map
